// extracted by mini-css-extract-plugin
module.exports = {"container":"image_container__2qTdY"};